interface KeyExchangeRequest{
    version:string,
    payload:unknown,
}
interface KeyExchangeResponse{
    version:string,
    payload:unknown,
}
export interface sysKeyExchange {
    publicKey:JsonWebKey,
    cryptoParameter:CryptoParameter,
    keyUpdate?:keyUpdateParamerter,
    recon?:reConnectParamerter,
}
export interface KeyRequest10 extends KeyExchangeRequest{
    version:"1.0",
    payload:{
        algrithm:"ECDH_P-521,AES-GCM_256,ECDSA_P-521_SHA521",//KeyExchange,DataCrypto,Sign
        publicLey:JsonWebKey,
        reConnection?:reConnectParamerter,
    },
}
export interface KeyResponse10 extends KeyExchangeResponse{
    version:"1.0",
    payload:{
        "sessionID":string,
        "sign":string,
        "key":{
            "keyId":string,
            "publicKey":JsonWebKey,
        }
    },
}
export interface reConnectParamerter{sessionId:string,keyId:string,sign:string}
export interface keyUpdateParamerter{sessionId:string,keyId:string,token:string}
export const isKeyUpdateParamerter = (obj:any):obj is keyUpdateParamerter => {
    if(obj && typeof obj === "object"){
        if(typeof obj["sessionId"] === "string" && typeof obj["keyId"] === "string" && typeof obj["token"] === "string"){
            return true;
        }
    }
    return false;
}

export interface CryptoParameter{
    public:PublicKeyParemeter,
    dataCrypto:DataCryptoParameter,
    sign:SignParameter,
}

export interface PublicKeyParemeter{
    algrithm:string,
    hash?:string,
    cryptParams:RsaKeyGenParams|EcKeyGenParams,
    usage:KeyUsage[],
}
export interface DataCryptoParameter{
    delivaryparam:AesDerivedKeyParams,
    algrithm:string,
    vectorSize:number,
    usage:KeyUsage[],
}
export interface SignParameter{
    keyAlgrithm:EcKeyGenParams,
    signParam:EcdsaParams
}
export const supportAlgrithm = {
    "1.0":{
        keyEx:["ECDH_P-521"],
        crypto:["AES-GCM_256"],
        sign:["ECDSA_P-521_SHA521"],
    }
}

export const cryptoApiParamerter = {
    keyExchange:{
        "ECDH_P-521":{
            "algrithm":"ECDH",
            "hash":"SHA-256",
            "cryptParams":{"name":"ECDH","namedCurve":"P-521"},
            "usage":["deriveKey","deriveBits"]
        }
    } as {[name:string]:PublicKeyParemeter},
    dataCypto:{
        "AES-GCM_256":{
            "delivaryparam":{"name":"AES-GCM","length":256},
            "algrithm":"AES-GCM",
            "vectorSize":12,
            "usage":["decrypt","encrypt"]
        }
    } as {[name:string]:DataCryptoParameter},
    sign:{
        "ECDSA_P-521_SHA521":{
            "keyAlgrithm":{"name":"ECDSA","namedCurve":"P-521"},
            "signParam":{"name":"ECDSA","hash":"SHA-512"}
        }
    } as {[name:string]:SignParameter}
}
export interface ClientList{
    [clientId:string]:ClientInfo
}
export interface ClientInfo{
    "sercretKey":string,
    "scope":string[],
}
export const singSize = (alg:SignParameter) =>{
    if(alg.keyAlgrithm?.name === "ECDSA"){
        if(alg.keyAlgrithm.namedCurve === "P-521"){
            return 521;
        }
    }
    return null;
}
function getSupportParameterPublic():Array<string>;
function getSupportParameterPublic(name:string):undefined|PublicKeyParemeter;
function getSupportParameterPublic(name?:string):Array<string>|undefined|PublicKeyParemeter{
    if(typeof name === "undefined"){
        return ["ECDH_P-521"];
    }
    return cryptoApiParamerter.keyExchange[name];
}

function getSupportParameterSign():Array<string>;
function getSupportParameterSign(name:string):undefined|SignParameter;
function getSupportParameterSign(name?:string):Array<string>|undefined|SignParameter{
    if(typeof name === "undefined"){
        return ["ECDSA_P-521_SHA521"];
    }
    return cryptoApiParamerter.sign[name];
}

function getSupportParameterCypto():Array<string>;
function getSupportParameterCypto(name:string):undefined|DataCryptoParameter;
function getSupportParameterCypto(name?:string):Array<string>|undefined|DataCryptoParameter{
    if(typeof name === "undefined"){
        return ["AES-GCM_256"];
    }
    return cryptoApiParamerter.dataCypto[name];
}

export const getSupportParameter = {
    public:getSupportParameterPublic,
    sign:getSupportParameterSign,
    datCrypto:getSupportParameterCypto,
}

export const chkKeyExReq = (keyreq:any):null|sysKeyExchange =>{
    if(typeof keyreq !== "object"){
        return null;
    }
    if(typeof keyreq.version !== "string"){
        return null;
    }
    switch (keyreq.version){
        case "1.0":{
            if(typeof keyreq.payload === "object"){
                if(typeof keyreq.payload.algrithm !== "string"){
                    return null;
                }
                const [keyex,crypto,sing] = keyreq.payload.algrithm.split(",");
                if(!supportAlgrithm["1.0"].keyEx.includes(keyex) || !supportAlgrithm["1.0"].crypto.includes(crypto) || !supportAlgrithm["1.0"].sign.includes(sing)){
                    return null;
                }
                const _p = getSupportParameter.public(keyex)
                const _s = getSupportParameter.sign(sing);
                const _d = getSupportParameter.datCrypto(crypto);
                if(!_p || !_s || !_d){
                    return null;
                }
                const ret = {
                    "publicKey":keyreq.payload.publickey as JsonWebKey,
                    "cryptoParameter":{
                        "public":_p,
                        "dataCrypto":_d,
                        "sign":_s,
                    }
                } as sysKeyExchange;
                if(keyreq.payload.recon){
                    ret["recon"] = keyreq.payload.recon;
                }
                if(keyreq.payload.keyUpdate){
                    ret["keyUpdate"] = keyreq.payload.keyUpdate;
                }
                return ret;
            }
            return null;
        }
        default:
            return null;
    }
}